






















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Image } from '@/types/image';

@Component({
  filters: {
    lowRes(url: string) {
      return url.replace('/images/', '/250x250/filters:format(webp)/images/');
    },
  },
})
export default class ImageTile extends Vue {
  @Prop() image!: Image;

  hasError: boolean = false;
}
